<template>
  <div class="page faq-page">
    <h1>{{ page.heading }}</h1>
    <p class="page-intro">关于产品、购买和联系方式的常见问题，这里先给出我们最常被问到的答案。</p>
    <ContactFriend placement="hero" />
    <section v-for="faq in faqs" :key="faq.question" class="faq-item">
      <h2>{{ faq.question }}</h2>
      <p>{{ faq.answer }}</p>
    </section>
  </div>
</template>

<script>
import ContactFriend from '@/components/ContactFriend.vue'
import { resolvePage } from '@/content/siteContent.mjs'

const page = resolvePage('/faq.html')

const FAQS = [
  {
    question: '滋仙草官网是哪个域名？',
    answer: '官方网站是 www.zixiancao.com，站内的品牌故事、产品、品质信息、常见问题和联系方式都在这个域名下。'
  },
  {
    question: '产品规格、配料和生产信息在哪里看？',
    answer: '具体规格、配料与生产信息以产品包装上的标示为准。想提前确认某一款的资料，可以联系企业顾问，我们会按包装标示答复。'
  },
  {
    question: '怎样联系企业顾问？',
    answer: '页面顶部的“加好友”按钮和各页的加好友入口都可以直接打开企业微信，联系页还有服务热线与商务合作邮箱。'
  },
  {
    question: '石斛原浆有哪几款？',
    answer: '目前有紫皮石斛原浆礼盒装、紫皮石斛原浆量贩装和铁皮石斛原浆三款，都可以在匠心产品页查看详情。'
  },
  {
    question: '价格与购买渠道在哪里？',
    answer: '官网不展示价格。当期价格、活动与购买渠道以官方店铺信息为准，也可以咨询企业顾问。'
  }
]

export default {
  name: 'FaqPage',
  components: {
    ContactFriend
  },
  data() {
    return { page, faqs: FAQS }
  }
}
</script>

<style scoped>
.page {
  max-width: 960px;
  margin: 0 auto;
  padding: 20px 16px 48px;
  text-align: left;
}

h1 {
  color: #4b0082;
  font-size: 1.5em;
  margin: 0 0 8px;
}

.faq-item {
  background: #fff;
  padding: 16px;
  border-radius: 16px;
  box-shadow: 0 4px 15px rgba(75, 0, 130, 0.06);
  margin-top: 14px;
}

.faq-item h2 {
  color: #4b0082;
  font-size: 1.05em;
  margin: 0 0 6px;
}

.page-intro,
.faq-item p {
  color: #333;
  line-height: 1.8;
  margin: 0;
}
</style>
